export const educationData = [
    {
        id: 1,
        institution: 'Masai School, Bengaluru',
        course: `Full Stack Web Development (MERN)`,
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Ignou, New Delhi, India',
        course: 'Bachlor of Computer Application',
        startYear: '2021',
        endYear: 'present'
    },
    {
        id: 3,
        institution: 'Paras Nath Kushwaha College',
        course: '12th(science)',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 4,
        institution: 'Bihar Public School',
        course: 'Schooling',
        startYear: '2014',
        endYear: '2019'
    },
]
